export default __webpack_public_path__ + "/assets/edi_big.png";